import 'jquery';

/**
 * persist input
 *
 * you can persist an input of a form field by using data attribute data-persist.
 *
 * The input state is memorized in the active javascript session while unloading a page without submitting it.
 * The key of field contains session id to prevent a persistance into a new session
 *
 */
(function ($, document, window) {
  var sessionId = $('body').data('session-id'), sessionStore;

  try {
    sessionStore = window.sessionStorage;
  } catch (exception) {
    console.warn('can not use session store to persist some fields', exception);
  }

  if ('undefined' === typeof sessionStore) {
    return;
  }

  $('form').on('input change', ':input[data-persist]', function () {
    // save values
    var value = $(this).val();

    if ($(this).is(':checkbox')) {
      value = $(this).is(':checked');
    } else if ($(this).is(':radio')) {
      value = $(':input[name=' + $(this).attr('name') + ']').filter(':checked').val();
    }

    sessionStore.setItem('persist-' + sessionId + $(this).attr('name'), value);

  }).on('submit', function () {
    // on submit all data will be saved server side
    $('[data-persist]').each(function () {
      sessionStore.removeItem('persist-' + sessionId + $(this).attr('name'));
    });
  });

  // fill values
  $('[data-persist]').each(function () {
    let value = sessionStore.getItem('persist-' + sessionId + $(this).attr('name'));

    // https://stackoverflow.com/a/17162375
    // if value === null its not in storage
    if (value === null) {
      return;
    }

    // checkboxes toggle its checked attribute
    if ($(this).is(':checkbox')) {
      // value is a string
      $(this).prop('checked', (value == 'true'));
    } else {
      $(this).val(value);
    }
  });

}(jQuery, document, window));